



































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import Vuelidate from 'vuelidate';
import { required, minLength, between } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import vSelect from 'vue-select';
import { ThingGroup, ThingGroupsApi } from '../../../api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		secondaryNav,
		vSelect,
		Toast,
	},
	validations: {
		form: {
			name: { required },
			firmwareVersion: { required },
		},
	},
	mixins: [validationMixin],
})
export default class ThingGroupCreate extends Vue {
	public form = {
		// transceiverID: '',
		name: '',
		firmwareVersion: '',
	};
	public errors = [];
	public transceivers: any = [];
	public $bvToast: any;
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public type = null;

	constructor() {
		super();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const group: ThingGroup = this.form;

		let response;

		try {
			response = await new ThingGroupsApi().createThingGroup({ data: group });
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Creating Thing Group', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('New Thing Group', 'Successfully Created', 'success');
		this.submitStatus = 'OK';

		setTimeout(() => {
			this.$router.push({ name: 'thing-groups.list' });
		}, 1000);
	}
}
